import { Assignment, Help, ManageAccounts, PictureAsPdf as PictureAsPdfIcon, Settings } from '@mui/icons-material';
import { lazy } from 'react';
import { Permissions } from 'services/enums';
import { DEVELOPMENT_LICENSE_ID, isDevelopmentAccountLicense } from '../routeUtils';
import { DEFAULT_ROUTE, IRouteProps } from '../types';

const ConfigurationsPage = lazy(() => import('pages/ConfigurationsPage'));
const LicensePage = lazy(() => import('pages/LicensePage'));
const ManagementPage = lazy(() => import('pages/ManagementPage'));
const ProposalPdfPage = lazy(() => import('pages/ProposalPdfPage'));
const HelpCenterPage = lazy(() => import('pages/HelpCenterPage'));

const proposalPdfRoute: IRouteProps = {
	type: 'collapse',
	name: 'routersNames.proposalPdf',
	key: 'proposalPdf',
	icon: <PictureAsPdfIcon />,
	route: `${DEFAULT_ROUTE}/Proposal`,
	permissionId: [Permissions.ALL],
	component: <ProposalPdfPage />,
	protected: true,
};

const licensesRoute: IRouteProps = {
	type: 'collapse',
	name: 'routersNames.licenses',
	key: 'licenses',
	icon: <Assignment />,
	route: `${DEFAULT_ROUTE}/licenses`,
	permissionId: [Permissions.ALL, Permissions.LICENSE_FINANCIAL, Permissions.LICENSE_COMMERCIAL],
	permissionMatch: 'any',
	requiredLicenseId: DEVELOPMENT_LICENSE_ID,
	component: <LicensePage />,
	protected: true,
};

export const settingsRoutes: IRouteProps[] = [
	...(isDevelopmentAccountLicense() ? [proposalPdfRoute] : []),
	licensesRoute,
	{
		type: 'collapse',
		name: 'routersNames.configuration',
		key: 'config',
		icon: <Settings />,
		permissionId: Permissions.CONFIG,
		route: `${DEFAULT_ROUTE}/configurations`,
		component: <ConfigurationsPage />,
		protected: true,
	},
	{
		type: 'collapse',
		name: 'routersNames.management',
		key: 'management',
		icon: <ManageAccounts />,
		route: `${DEFAULT_ROUTE}/management`,
		component: <ManagementPage />,
		protected: true,
	},
	{
		type: 'collapse',
		name: 'routersNames.helpCenter',
		key: 'help-center',
		icon: <Help />,
		route: `${DEFAULT_ROUTE}/ajuda`,
		matchPath: `${DEFAULT_ROUTE}/ajuda/*`,
		permissionId: [Permissions.ALL],
		component: <HelpCenterPage />,
		protected: true,
	},
];
